class NwParallax extends HTMLElement {
    constructor() {
        super();

        this.layers = this.querySelectorAll('.nw-parallax-layer');
        this.translateLimitFactor = this.getTranslateLimitFactor();

        this.bindEvents();
    }

    bindEvents() {
        const speedFactor = 2;

        window.addEventListener('scroll', () => {
            for (const [index, layer] of this.layers.entries()) {
                // Do not translate these infinitely with the scroll
                const maxTranslateY = this.clientHeight * this.translateLimitFactor * (index / this.layers.length);

                // Further layers will scroll slower
                const translateY = Math.min(maxTranslateY, window.scrollY * index / this.layers.length * speedFactor);

                layer.style.transform = `translateY(-${translateY}px)`;
            }
        }, false);

        window.addEventListener('resize', () => {
            this.translateLimitFactor = this.getTranslateLimitFactor();
        });
    }

    getTranslateLimitFactor() {
        return window.matchMedia("(min-width: 576px)").matches ? 0.5 : 0.75;
    }
}

customElements.define('nw-parallax', NwParallax);
